<template>
    <div class="container">
        <div class="row trees-row py-4">
            <div class="count your-trees"
                :class="open ? 'fullcounter-wrapper' : 'counter-wrapper'">
                <h5 class="counter font-weight-bold">{{userTrees}}
                    <img src="../assets/dark-tree.svg" style="width:1rem" class="img-responsive"/>
                </h5>
                <h6 class="counter-title" v-html="locale.your_trees">Your trees</h6>
            </div>
            <div class="count" :class="open ? 'voidcounter-wrapper' : 'counter-wrapper'">
                <h5 class="counter font-weight-bold">{{totalTrees}}
                    <img src="../assets/dark-tree.svg" style="width:1rem" class="img-responsive"/>

                </h5>
                <h6 class="counter-title" v-html="locale.total">Total</h6>
            </div>
        </div>
    </div>
</template>
<script>
// import axios from "axios";

export default {
    props:["totalTrees","userTrees","open"],
    data(){
        return{
            locale: this.$locale.head
        }
    }
    
}
</script>
<style scoped>
    .your-trees.counter-wrapper{
        border-right: 2px solid #6AB04C;
    }

    .trees-row{
        text-align: center;
    }
    
    .count{
        /* transition: all .3s cubic-bezier(.6,0,.45,1.3); */
        transition: all .3s ease-in-out;
    }
    .counter-wrapper{
        width: 50vw;
    }
    .fullcounter-wrapper{
        width: 100vw;
    }
    .voidcounter-wrapper{
        width: 0vw;
        height: 0;
    }
</style>